<template>
  <div class="car-type">
    <div class="car-type__purpose">
      <!-- 标题区域 -->
      <div class="car-type__title">
        <div class="car-type__heading">Browse by Purpose</div>
        <a class="car-type__view" :href="getHrefForAll()">
          <div class="car-type__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-type__icon" alt="view all">
        </a>
      </div>

      <!-- 类型卡片区域：PC横向，移动端纵向 -->
      <div class="car-type__cards" :class="{'car-type__cards--mobile': deviceType === 'mobile'}">
        <a v-for="(type, index) in carTypes" :key="`type-${index}`" class="car-type__card"
          :href="getHrefForPurpose(type.value)">
          <div class="car-type__card-image">
            <img :src="type.icon" class="car-type__icon-img" :alt="`${type.name} icon`">
          </div>
          <div class="car-type__card-label">
            <div class="car-type__card-name">{{ type.name }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarType',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    })
  },
  data () {
    return {
      carTypes: [
        {
          name: 'Family Car',
          value: 'Family Vehicle',
          icon: require('../assets/type/family_car.png')
        },
        {
          name: 'Commercial Vehicle',
          value: 'Commercial Vehicle',
          icon: require('@/assets/type/commercial_vehicle.png')
        },
        {
          name: 'Off-Road Vehicle',
          value: 'Cross Country Vehicle',
          icon: require('@/assets/type/offroad_vehicle.png')
        },
        {
          name: 'Sports Car',
          value: 'Sport Vehicle',
          icon: require('@/assets/type/sports_car.png')
        }
      ]
    }
  },
  methods: {
    // Generate href for "View All" link
    getHrefForAll () {
      const currentChannel = this.$route.params.channel;
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/car-list${fullQueryString}`;
      }
      return `/car-list${fullQueryString}`;
    },

    // Generate href for purpose filter
    getHrefForPurpose (purpose) {
      if (!purpose) {
        return 'javascript:void(0);';
      }
      const currentChannel = this.$route.params.channel;
      const currentParams = new URLSearchParams(this.$route.query);
      currentParams.set('purpose', purpose);
      const fullQueryString = `?${currentParams.toString()}`;

      if (currentChannel) {
        return `/${currentChannel}/car-list${fullQueryString}`;
      }
      return `/car-list${fullQueryString}`;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-type {
	padding: rem(60) 0;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__purpose {
		padding: 0 rem(120);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		box-sizing: border-box;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #141414;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(12);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 600;
		color: var(--theme-color);
	}

	&__icon {
		flex-shrink: 0;
		width: rem(16);
		height: rem(16);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: stretch;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
		width: 100%;
		margin-top: rem(20);

		// 移动端样式 - 纵向排列
		&--mobile {
			flex-direction: column;
			gap: rem(16);
		}
	}

	&__card {
		position: relative;
		flex: 1;
		border-radius: rem(24);
		overflow: hidden;
		cursor: pointer;
		transition: transform 0.3s ease;
		height: rem(170);

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 rem(8) rem(16) rgba(0, 0, 0, 0.15);
		}
	}

	&__card-image {
		width: 100%;
		height: rem(134);
		background: #141414;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	&__icon-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: relative;
	}

	&__card-label {
		background: var(--theme-color);
		border-radius: 0 0 rem(24) rem(24);
		width: 100%;
		padding: rem(10) rem(12);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__card-name {
		color: #ffffff;
		text-align: center;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 600;
		position: relative;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-type {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-type {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(40) 0;

		&__purpose {
			padding: 0 rem(16);
			width: 100%;
		}

		&__card {
			height: rem(170);
		}

		&__card-image {
			height: rem(134);
		}
	}
}
</style> 